import {
  get,
  post,
  error
} from '@/api/common.js'

function getCount(path, that) {
  get(path).then(function(Response) {
    that.count = Math.ceil(Response.data / 7);
  }, function(Response) {
    error(Response);
  });
}

function getNavigationMenu(path, that) {
  get(path).then(function(Response) {
    var arr = Response.data;
    that.items = arr;
    getNavigation("item/get?nid=" + arr[0].id, that);
  }, function(Response) {
    error(Response);
  });
}

function getNavigation(path, that) {
  get(path).then(function(Response) {
    that.showList = Response.data;
  }, function(Response) {
    error(Response);
  });
}

export {
  getCount,
  getNavigationMenu,
  getNavigation,
}



// WEBPACK FOOTER //
// ./src/api/navigation.js